"use client";

import { useEffect, useState } from "react";

import clsx from "clsx";

import { USE_EZOIC } from "shared-lib/constants";
import { useCustomGate } from "shared-lib/helpers/customStatSigHooks";
import { ezoicDisplayMoreAds } from "shared-lib/helpers/ezoicFunctions";
import { log } from "shared-lib/helpers/logging/logger";

import { EZOIC_RECIPE_PAGE_PLACEHOLDERS_DISPLAY_MORE } from "@/lib/constants";

export default function ChicoryAisle() {
  const props = {
    "chicory-aisle-type": "horizontal",
    "chicory-require-ads": "true",
  };
  const ezoiChicoryAisleGate = useCustomGate("chicory_aisle_event_gate");
  const [chicoryAdAvailable, setChicoryAdAvailable] = useState<boolean>(true);

  if (USE_EZOIC && !ezoiChicoryAisleGate) {
    ezoicDisplayMoreAds(EZOIC_RECIPE_PAGE_PLACEHOLDERS_DISPLAY_MORE);
  }

  useEffect(() => {
    const requestEzoicPlaceholder = () => {
      log("Chicory Aisle: calling for 119 from Ezoic");
      ezoicDisplayMoreAds(EZOIC_RECIPE_PAGE_PLACEHOLDERS_DISPLAY_MORE);

      log("Chicory Aisle: Set not-rendered class for Chicory Aisle Mile");
      setChicoryAdAvailable(false);

      log(
        "Chicory Aisle: Notify Mile through mileExternalTriggerForAdUnitRender custom event",
      );
      const event = new CustomEvent("mileExternalTriggerForAdUnitRender", {
        detail: { id: "fi-ash-1726812655-5661", dynamic: true },
      });
      window.dispatchEvent(event);
    };

    window.addEventListener("chicory_aisle_no_ads", requestEzoicPlaceholder);

    // Debug dispatched event
    // window.addEventListener("mileExternalTriggerForAdUnitRender", (e) => console.log("Chicory Aisle (Mile Listener): ", e.detail));

    return () => {
      window.removeEventListener(
        "chicory_aisle_no_ads",
        requestEzoicPlaceholder,
      );
    };
  }, []);

  return (
    <>
      {ezoiChicoryAisleGate && (
        <div
          id="chicory-aisle-slot"
          {...props}
          className={clsx(!chicoryAdAvailable && "not-rendered")}
        />
      )}
    </>
  );
}
